import { IconType } from "react-icons";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  Icon?: IconType;
  buttonLabel?: string;
}

export const ButtonIcon: React.FC<ButtonProps> = ({ Icon, buttonLabel, ...rest }) => (
  <button {...rest} className={`${rest?.className || ''} gm-button-icon`}>
    {Icon && <Icon size={16} />}
    {buttonLabel || ''}
  </button>
);
